import { useEffect, useState } from "react";

// Isolated seconds ticker — fixed-width so it never shifts the layout of siblings.
export function SecondsTicker({ className = "" }) {
  const [s, setS] = useState(new Date().getSeconds());
  useEffect(() => {
    const t = setInterval(() => setS(new Date().getSeconds()), 1000);
    return () => clearInterval(t);
  }, []);
  return <span className={`inline-block w-[2ch] tabular-nums text-center ${className}`}>{String(s).padStart(2, "0")}</span>;
}
